import '/assets/styles/layouts/checkout.scss';
import loadable from '@loadable/component';

// Sections
import CheckoutHeader from '/views/sections/header-checkout';
import Footer from '/views/sections/footer';

// Partials
import Loader from '/views/partials/loader';

// Context
import { useAuth } from '@wearetla/tla-essentials-tools/utilities/auth';

const CheckoutAuth = loadable(
	() => import(/* webpackPrefetch: true */ '/views/pages/checkout-auth')
);

const CheckoutLayout = ({ children, pageClass, requiresLogin }) => {
	const { loggedIn, initialized } = useAuth();

	return (
		<div className={`page layout-checkout ${pageClass ? 'page-' + pageClass : ''}`}>
			<CheckoutHeader />
			<div className="loader-container">
				<Loader dark loading={requiresLogin && !initialized} />
				{(!requiresLogin || initialized) && (
					<>{!requiresLogin || loggedIn ? children : <CheckoutAuth />}</>
				)}
			</div>
			<Footer plain />
		</div>
	);
};

export default CheckoutLayout;
